import React from 'react';
import PropTypes from 'prop-types';

/**
 * DeckSelectionScreen - Initial screen where users choose their card selection method
 */
export default function DeckSelectionScreen({ onMethodSelect }) {
  return (
    <div className="deck-selection-screen">
      <div className="selection-container">
        <h1 className="heading-primary mb-8">✦ Welcome to the Third Card Oracle ✦</h1>
        
        <p className="text-lg text-amber-200 mb-12 max-w-2xl mx-auto">
          Choose two cards to reveal The Third Card—hidden wisdom that bridges any two-card Tarot reading.
        </p>

        <div className="selection-buttons">
          <button
            className="selection-button"
            onClick={() => onMethodSelect('physical')}
          >
            <div className="button-icon">🃏</div>
            <h3 className="button-title">I Have a Physical Deck</h3>
            <p className="button-description">
              Choose from dropdowns to match the cards you drew
            </p>
          </button>

          <button
            className="selection-button"
            onClick={() => onMethodSelect('digital')}
          >
            <div className="button-icon">✨</div>
            <h3 className="button-title">Pick Cards With Me</h3>
            <p className="button-description">
              Select from our interactive digital spread
            </p>
          </button>
        </div>
      </div>
    </div>
  );
}

DeckSelectionScreen.propTypes = {
  onMethodSelect: PropTypes.func.isRequired,
};
